import { select, take } from "redux-saga/effects";
import TagManager from "react-gtm-module";
import { SET_SESSION_DATA } from "../../actions/sessionActions";
import { getFrontendSettings } from "../selectors";

export function* initGoogleTagManagerSaga(): any {
    yield take(SET_SESSION_DATA);

    const frontendSettings = yield select(getFrontendSettings);

    if (!frontendSettings.gtm_enabled) {
        return;
    }

    const GTM_IDS = [frontendSettings.gtm_internal_id, frontendSettings.gtm_external_id];

    GTM_IDS.filter(Boolean).forEach(gtmId => {
        TagManager.initialize({ gtmId });
    });
}
